import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { RootState } from '../State/store';
import { CircularProgress } from '@mui/material';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../Components/ui/table';
import * as XLSX from 'xlsx';
import { Badge } from '../Components/ui/badge';
import {
  CaretSortIcon,
  CheckIcon,
  Cross2Icon,
  MagnifyingGlassIcon,
  PauseIcon,
  PlayIcon,
  StopwatchIcon,
  DotsHorizontalIcon,
} from '@radix-ui/react-icons';
import {
  CheckCircle,
  Clock,
  FileIcon,
  HelpCircle,
  Loader2,
  XCircle,
} from 'lucide-react';
import { ToastContainer } from 'react-toastify';
import { DateRange } from 'react-day-picker';
import { Input } from '../Components/ui/input';
import { Button } from '../Components/ui/button';
import { format } from 'date-fns';
import { useToast } from '../Components/ui/use-toast';
import { Toaster } from '../Components/ui/toaster';
import OperatorTemplateDropdown from '../Components/Filter/OperatorTemplateDropdown';
import TemplatePreviewModal from './TemplatePreviewModel';

import { RefreshCw } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger } from '../Components/ui/tabs';
// import CreateContentForm from "../AdminTemplates/CreateContentForm"
import CreateContentForm from '../Operator/CreateContentTemplateForm';
// Add DotsHorizontalIcon to your existing @radix-ui/react-icons import

// Add DropdownMenu imports (new import block)
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../Components/ui/dropdown-menu';

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../Components/ui/dialog';
import { useLocation } from 'react-router-dom';

interface TemplateRow {
  operator_mapping_id: number;
  template_id: number;
  campaign_name?: string;
  template_name: string;
  channel_type: string;
  template_type: string;
  status: string;
  whatsapp_status: string;
  last_updated: string;
  isUsedAsWm: boolean; // ← ADD THIS
}

const OperatorTemplateList: React.FC = () => {
  const toast = useToast();
  const [dateRange, setDateRange] = useState<DateRange | undefined>();
  const [templateList, setTemplateList] = useState<TemplateRow[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [campaignLoading, setCampaignLoading] = useState(true);
  const [hasTemplates, setHasTemplates] = useState(false);
  const [initialFetched, setInitialFetched] = useState(false);
  const [filterData, setFilterData] = useState({
    filter: 'None',
    subFilter: '',
  });
  const [dateList, setDateList] = useState<string[]>([]);
  const [checkboxSelectedRows, setCheckboxSelectedRows] = useState<number[]>(
    [],
  );
  const [dialogMode, setDialogMode] = useState<'create' | 'edit' | 'view'>(
    'create',
  );
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10); // Default 5 rows per page
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
  const [isClearingSearch, setIsClearingSearch] = useState(false);
  const [isClearingDate, setIsClearingDate] = useState(false);
  const [isCampaignTemplatePreview, setIsCampaignTemplatePreview] =
    useState(false);
  const [isDeleted, setIsDeleted] = useState(false);
  const [isExporting, setIsExporting] = useState(false);
  //const [isLoading, setIsLoading] = useState(false);

  // const operatorId = useSelector(
  //   (state: RootState) => state.authentication.workspace_id
  // );

  const operatorId = useSelector(
    (state: RootState) => state.authentication.workspace_id,
  );

  const operatorUrl = useSelector(
    (state: RootState) => state.authentication.operatorUrl,
  );

  const accountId = useSelector(
    (state: RootState) => state.authentication.account_id,
  );

  const impersonatorAID = useSelector(
    (state: RootState) => state.admin.Impersonator?.ImpersonatorAID,
  );

  const isImpersonated = useSelector(
    (state: RootState) => state.admin.Impersonator?.ImpersonationState,
  );

  const [everHadTemplates, setEverHadTemplates] = useState(false);
  const debounceTimeoutRef = useRef<any>(null);
  const [sortField, setSortField] = useState<keyof TemplateRow | null>(null);
  const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('asc');
  const bothDatesSelected = dateRange?.from && dateRange?.to;
  const bothDatesCleared = !dateRange?.from && !dateRange?.to;
  const singleDateSelected = dateRange?.from && !dateRange?.to;

  const [isRefreshing, setIsRefreshing] = useState(false);

  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState<any>(null);
  const [selectedTemplateId, setSelectedTemplateId] = useState<any>(null);
  const [selectedTemplateName, setSelectedTemplateName] = useState<any>(null);
  const [openTemplateDialog, setOpenTemplateDialog] = useState(false);
  const [openMenuRowId, setOpenMenuRowId] = useState<number | null>(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const toastHook = useToast();
  const adminUrl = useSelector(
    (state: RootState) => state.authentication.adminUrl,
  );

  const location = useLocation();

  const locationState = location.state as LocationState | null;

  const initialTab: 'campaign' | 'welcome' = locationState?.action
    ?.toLowerCase()
    .includes('welcome')
    ? 'welcome'
    : 'campaign';

  const [activeTemplateTab, setActiveTemplateTab] = useState<
    'campaign' | 'welcome'
  >(initialTab);

  interface LocationState {
    templateId?: number;
    action?: string;
  }

  const { templateId } = (location.state as LocationState) || {};
  const { action } = (location.state as LocationState) || {};

  // No welcome templates yet

  // const fetchTemplates = async (
  //   pageNumber: number,
  //   pageSize: number,
  //   search?: string,
  // ) => {
  //   if (!operatorId || !operatorUrl) return;

  //   setLoading(true);
  //   try {
  //     const response = await axios.get(
  //       `${operatorUrl}/GetTemplatesByOperatorId`,
  //       {
  //         params: {
  //           operatorId: operatorId,
  //           pageNumber: currentPage, // 🔁 You'll need to define this in state
  //           pageSize: pageSize, // 🔁 And this too
  //           searchTerm: searchTerm || null, // 🔁 Optional search string
  //         },
  //       },
  //     );

  //     if (response.status === 200 && response.data.templatesDetails) {
  //       debugger;
  //       setTemplateList(response.data.templatesDetails);
  //       setTotalCount(response.data.totalCount);
  //       setHasTemplates(response.data.templatesDetails.length > 0);
  //       setDateList(response.data.lastEditedDates || []);
  //       setCheckboxSelectedRows([]);
  //       setIsAllSelected(false);
  //       if (response.data.templatesDetails.length > 0) {
  //         setTotalCount(response.data.templatesDetails[0].total_count); // 🧮 total_count for pagination
  //       } else {
  //         setTemplateList([]);
  //         setTotalCount(0);
  //         setDateList([]);
  //         setHasTemplates(false);
  //       }
  //     } else {
  //       setTemplateList([]);
  //       setTotalCount(0);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching template list:", error);
  //     setTemplateList([]);
  //     setTotalCount(0);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  useEffect(() => {
    if (!location.state) return;

    const state = location.state as LocationState;

    const fetchTemplate = async () => {
      if (
        state.templateId &&
        state.action &&
        state.action.toLowerCase().includes('welcome')
      ) {
        // Switch to Welcome tab
        setActiveTemplateTab('welcome');

        try {
          const res = await axios.get(`${operatorUrl}/GetTemplateContentById`, {
            params: {
              templateId: state.templateId,
            },
          });

          console.log('Template response:', res.data);
        } catch (error) {
          console.error('Error fetching template:', error);
        }

        // Open preview automatically
        handleTemplateNameClick({
          template_id: state.templateId,

          template_name: '',
        });
      }
    };

    fetchTemplate();
    // Clear navigation state
    window.history.replaceState({}, document.title);
  }, [location.state]);

  const handleView = async (template_Id: number) => {
    if (!template_Id) {
      toastHook.toast({
        title: 'Error',
        description: 'Template ID not found',
        variant: 'destructive',
      });
      return;
    }

    setOpenTemplateDialog(true);
    setDialogMode('view');
    setSelectedTemplate(null);

    try {
      const response = await axios.get(
        `${adminUrl}/GetTemplateById?templateId=${template_Id}`,
      );

      if (response.data) {
        setSelectedTemplate(response.data);
      } else {
        toastHook.toast({
          title: 'Error',
          description: 'Failed to fetch template',
          variant: 'destructive',
        });
        setOpenTemplateDialog(false);
      }
    } catch (error) {
      console.error('Error fetching template for view:', error);
      toastHook.toast({
        title: 'Error',
        description: 'Failed to fetch template details',
        variant: 'destructive',
      });
      setOpenTemplateDialog(false);
    }
  };

  const handleEdit = async (template_Id: number) => {
    if (!template_Id) {
      toastHook.toast({
        title: 'Error',
        description: 'Template ID not found',
        variant: 'destructive',
      });
      return;
    }

    setOpenTemplateDialog(true);
    setDialogMode('edit');
    setSelectedTemplate(null);

    try {
      const response = await axios.get(
        `${adminUrl}/GetTemplateById?templateId=${template_Id}`,
      );

      if (response.data) {
        setSelectedTemplate(response.data);
      } else {
        toastHook.toast({
          title: 'Error',
          description: 'Failed to fetch template',
          variant: 'destructive',
        });
        setOpenTemplateDialog(false);
      }
    } catch (error) {
      console.error('Error fetching template for edit:', error);
      toastHook.toast({
        title: 'Error',
        description: 'Failed to fetch template details',
        variant: 'destructive',
      });
      setOpenTemplateDialog(false);
    }
  };

  const handleDelete = async (templateId: number) => {
    try {
      const res = await axios.delete(`${operatorUrl}/DeleteTemplate`, {
        params: {
          template_id: templateId,
          accountId: accountId,
          workspaceId: operatorId,
          ImpersonatorUserAccountId: isImpersonated ? impersonatorAID : null,
        },
      });

      console.log('API Response:', res.data);

      toastApi.toast({
        title: res.data.status,
        description: res.data.status_description,
      });

      fetchWelcomeTemplates(currentPage, rowsPerPage, searchTerm);
    } catch (error) {
      console.error('Delete failed', error);

      toastApi.toast({
        title: 'Error',
        description: 'Failed to delete template',
        variant: 'destructive',
      });
    }
  };

  const handleCheckWelcomeTemplateDeletedStatus = async (
    templateId: number,
  ) => {
    try {
      const response = await axios.get(
        `${adminUrl}/GetWelcomeTemplateDeletedStatus`,
        {
          params: {
            templateId,
          },
        },
      );

      return response.data?.isDeleted ?? false;
    } catch (error) {
      console.error('Error checking welcome template deleted status:', error);

      return false;
    }
  };

  const fetchCampaignTemplates = async (
    pageNumber: number,
    pageSize: number,
    search?: string,
  ) => {
    if (!operatorId || !operatorUrl) {
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const response = await axios.get(
        `${operatorUrl}/GetTemplatesByOperatorId`,
        {
          params: {
            operatorId,
            pageNumber,
            pageSize,
            searchTerm: search || null,
          },
        },
      );
      debugger;

      setTemplateList(response.data.templatesDetails ?? []);
      setDateList(response.data.lastEditedDates ?? []);
      console.log('my campaign data', setTemplateList);
      setTotalCount(response.data.totalCount ?? 0);
    } catch (error) {
      console.error(error);
      setTemplateList([]);
      setTotalCount(0);
    } finally {
      setLoading(false);
    }
  };

  debugger;

  // const handleTemplateNameClick = async (template: any) => {
  //   try {
  //     // Fetch template content with template_id and channel_type
  //     const res = await axios.get(`${operatorUrl}/GetTemplateContentById`, {
  //       params: {
  //         templateId: template.template_id,
  //         channelType: template.channel_type, // Add channel type to API call
  //       },
  //     });

  //     // The API returns: { status, status_Description, templateContent }
  //     // templateContent is a JSON string that needs to be parsed
  //     const templateData = res.data.templateContent;
  //     debugger
  //     console.log(templateData);

  //     // Parse if it's a string
  //     const parsedTemplate =
  //       typeof templateData === "string"
  //         ? JSON.parse(templateData)
  //         : templateData;

  //     // Add channel_type to the template data
  //     parsedTemplate.template_type = template.channel_type;
  //     parsedTemplate.template_name = template.template_name;

  //     setSelectedTemplate(parsedTemplate);
  //     setSelectedTemplateId(template.template_id);
  //     setIsPreviewModalOpen(true);
  //   } catch (error) {
  //     console.error("Error fetching template:", error);
  //     // Handle error - show toast or error message
  //   }
  // };

  const handleTemplateNameClick = async (template: any) => {
    try {
      const isDeleted = await handleCheckWelcomeTemplateDeletedStatus(
        template.template_id,
      );

      if (isDeleted) {
        setIsDeleted(true);
        setIsPreviewModalOpen(true);
        return;
      }

      setIsDeleted(false);

      const res = await axios.get(`${operatorUrl}/GetTemplateContentById`, {
        params: {
          templateId: template.template_id,
          channelType: template.channel_type,
        },
      });

      debugger;

      const templateData = res.data.templateContent;

      // Parse string JSON
      const parsedTemplate =
        typeof templateData === 'string'
          ? JSON.parse(templateData)
          : templateData;

      // Get operator status
      let operatorStatus = parsedTemplate.operator_final_status || 'pending';

      // Get template_content
      const templateContent = parsedTemplate;

      // Add extra fields
      templateContent.template_type = template.channel_type;
      templateContent.template_name = template.template_name;
      templateContent.operator_status = operatorStatus;

      console.log('Template Content:', templateContent);
      console.log('Message:', templateContent?.message);

      setSelectedTemplate(templateContent);

      setSelectedTemplateId(template.template_id);
      setSelectedTemplateName(template.template_name);
      setIsPreviewModalOpen(true);
    } catch (error) {
      console.error('Error fetching template:', error);
    }
  };

  const handleCampaignTemplateClick = async (template: any) => {
    try {
      const res = await axios.get(
        `${operatorUrl}/GetTemplateJsonByOperatorMappingId`,
        {
          params: {
            operatorMappingId: template.operator_mapping_id,
          },
        },
      );

      const templateData = res.data.templateJson;

      const parsedTemplate =
        typeof templateData === 'string'
          ? JSON.parse(templateData)
          : templateData;

      let operatorStatus = parsedTemplate.operator_final_status || 'pending';

      const templateContent = {
        ...parsedTemplate,
        template_type: template.channel_type,
        template_name: parsedTemplate?.name || template.template_name || '',
        operator_status: template.approval_status || 'pending',
        campaign_name: template.campaign_name || '',
      };

      templateContent.operator_status = operatorStatus;

      debugger;

      console.log('Campaign Template Content:', templateContent);
      setIsCampaignTemplatePreview(true);
      setSelectedTemplate(templateContent);
      setSelectedTemplateId(template.template_id);
      setSelectedTemplateName(templateContent.template_name);
      setIsPreviewModalOpen(true);
    } catch (error) {
      console.error('Error fetching campaign template:', error);
    }
  };

  const toastApi = useToast();

  const handleApprove = async () => {
    try {
      await axios.put(`${operatorUrl}/WelcomeOperatorApproval`, null, {
        params: {
          templateId: selectedTemplateId,
          status: 'approved',
          accountId: accountId,
          workspaceId: operatorId,
          comment: '',
        },
      });

      setIsPreviewModalOpen(false);

      fetchWelcomeTemplates(currentPage, rowsPerPage, searchTerm);

      toastApi.toast({
        title: 'Success',
        description: 'Template approved successfully',
      });
    } catch (err) {
      console.error('Approve failed', err);

      toastApi.toast({
        title: 'Error',
        description: 'Failed to approve template',
        variant: 'destructive',
      });
    }
  };

  // const handleReject = async () => {
  //   try {
  //     await axios.put(`${operatorUrl}/WelcomeOperatorApproval`, null, {
  //       params: {
  //         templateId: selectedTemplateId,
  //         status: "rejected",
  //         accountId: accountId,
  //         workspaceId: operatorId,
  //         comment: rejectReason   // 👈 sending reject comment
  //       },
  //     });

  //     setIsPreviewModalOpen(false);
  //   } catch (err) {
  //     console.error("Reject failed", err);
  //   }
  // };

  const fetchWelcomeTemplates = async (
    pageNumber: number,
    pageSize: number,
    search?: string,
  ) => {
    if (!operatorId || !operatorUrl) {
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const response = await axios.get(
        `${operatorUrl}/GetWelcomeTemplatesByPartner`,
        {
          params: {
            partnerId: operatorId,
            pageNumber,
            pageSize,
            searchTerm: search || null,
          },
        },
      );
      debugger;
      setTemplateList(response.data.templates ?? []);
      setDateList(response.data.lastEditedDates ?? []);
      setTotalCount(response.data.totalCount ?? 0);
    } catch (error) {
      console.error(error);
      setTemplateList([]);
      setTotalCount(0);
    } finally {
      setLoading(false);
    }
  };

  const fetchTemplatesByTab = async (
    pageNumber: number,
    pageSize: number,
    search?: string,
  ) => {
    setLoading(true); // 🔥 start table-body loader

    try {
      if (activeTemplateTab === 'campaign') {
        await fetchCampaignTemplates(pageNumber, pageSize, search);
      } else {
        await fetchWelcomeTemplates(pageNumber, pageSize, search);
      }
    } finally {
      setLoading(false); // 🔥 stop loader ONLY after data arrives
    }
  };

  // useEffect(() => {
  //   if (!operatorUrl || !operatorId) return;

  //   // Only run once on initial load
  //   if (!initialFetched && filterData.filter === "None") {
  //     setInitialFetched(true);
  //     fetchTemplates(currentPage, rowsPerPage, searchTerm);
  //     return;
  //   }

  //   // Run on page or size change
  //   if (initialFetched && filterData.filter === "None") {
  //     fetchTemplates(currentPage, rowsPerPage, searchTerm);
  //   }
  // }, [operatorUrl, operatorId, currentPage, rowsPerPage, filterData]);

  useEffect(() => {
    if (!operatorUrl || !operatorId) return;

    fetchTemplatesByTab(currentPage, rowsPerPage, searchTerm);
  }, [
    operatorUrl,
    operatorId,
    currentPage,
    rowsPerPage,
    searchTerm,
    activeTemplateTab, //
  ]);

  useEffect(() => {
    setFilterData({
      filter: 'None',
      subFilter: '',
    });
  }, [activeTemplateTab]);

  useEffect(() => {
    setTimeout(() => {
      document.body.style.pointerEvents = '';
    }, 500);
  }, [isDialogOpen, openTemplateDialog]);

  // useEffect(() => {
  //   if (filterData.filter !== "None" || !initialFetched) return;

  //   if (debounceTimeoutRef.current) clearTimeout(debounceTimeoutRef.current);

  //   debounceTimeoutRef.current = setTimeout(() => {
  //     setCurrentPage(1);
  //     fetchTemplates(1, rowsPerPage, searchTerm);
  //   }, 500);

  //   return () => {
  //     if (debounceTimeoutRef.current) clearTimeout(debounceTimeoutRef.current);
  //   };
  // }, [searchTerm]);

  useEffect(() => {
    if (filterData.filter !== 'None' || !initialFetched) return;

    if (debounceTimeoutRef.current) clearTimeout(debounceTimeoutRef.current);

    debounceTimeoutRef.current = setTimeout(() => {
      setCurrentPage(1);
      fetchTemplatesByTab(1, rowsPerPage, searchTerm);
    }, 500);

    return () => {
      if (debounceTimeoutRef.current) clearTimeout(debounceTimeoutRef.current);
    };
  }, [searchTerm]);

  // useEffect(() => {
  //   if (
  //     filterData.filter !== "None" &&
  //     filterData.value !== "" &&
  //     operatorId &&
  //     operatorUrl
  //   ) {
  //     fetchFilteredTemplates(filterData.filter, filterData.value);
  //   }
  // }, [filterData, currentPage, rowsPerPage, operatorUrl, operatorId]);

  // useEffect(() => {
  //   if (!operatorId || !operatorUrl) return;

  //   if (
  //     filterData.filter !== "None" &&
  //     filterData.value !== ""
  //   ) {
  //     fetchFilteredTemplates(
  //       filterData.filter,
  //       filterData.value
  //     );
  //   } else if (filterData.filter === "None") {
  //     if (activeTemplateTab === "campaign") {
  //       fetchCampaignTemplates(
  //         currentPage,
  //         rowsPerPage,
  //         searchTerm
  //       );
  //     } else {
  //       fetchWelcomeTemplates(
  //         currentPage,
  //         rowsPerPage,
  //         searchTerm
  //       );
  //     }
  //   }
  // }, [
  //   filterData,
  //   currentPage,
  //   rowsPerPage,
  //   operatorUrl,
  //   operatorId,
  //   searchTerm,
  // ]);

  useEffect(() => {
    if (!operatorId || !operatorUrl) return;

    const hasFilter =
      filterData.filter !== 'None' && filterData.subFilter !== '';
    const hasFilterSelected = filterData.filter !== 'None'; // ← filter chosen but value may be empty

    // If a filter is selected but value not yet entered — do nothing, wait for value
    if (hasFilterSelected && !hasFilter) return;

    if (activeTemplateTab === 'campaign') {
      if (hasFilter) {
        fetchFilteredTemplates(filterData.filter, filterData.subFilter);
      } else {
        fetchCampaignTemplates(currentPage, rowsPerPage, searchTerm);
      }
    } else {
      if (hasFilter) {
        fetchFilteredTemplates(filterData.filter, filterData.subFilter);
      } else {
        fetchWelcomeTemplates(currentPage, rowsPerPage, searchTerm);
      }
    }
  }, [
    activeTemplateTab,
    filterData,
    currentPage,
    rowsPerPage,
    operatorUrl,
    operatorId,
    searchTerm,
  ]);
  const fetchFilteredTemplates = async (
    criteria: string,
    subFilter: string,
  ) => {
    debugger;
    setLoading(true);

    try {
      const response = await axios.get(
        `${operatorUrl}/GetOperatorTemplatesWithFilter`,
        {
          params: {
            operatorId: operatorId,
            templateType:
              activeTemplateTab === 'campaign' ? 'campaign' : 'welcome',
            criteria: criteria,
            subFilter: subFilter,
            pageNumber: currentPage,
            pageSize: rowsPerPage,
          },
        },
      );

      if (response.status === 200 && response.data.templates.length > 0) {
        debugger;
        setTemplateList(response.data.templates);
        setTotalCount(response.data.templates[0].filtered_count);
        // Track if we ever had templates
        if (response.data.filteredCount > 0) {
          setEverHadTemplates(true);
        }
      } else {
        setTemplateList([]);
        setTotalCount(0);
      }
    } catch (error) {
      toast.toast({
        title: 'Error',
        description: 'Failed to fetch filtered templates.',
      });
      setTemplateList([]);
      setTotalCount(0);
      setDateList([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setHasTemplates(templateList.length > 0);
  }, [templateList]);

  const handlePageChange = (newPage: number) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleRowsPerPageChange = (newRowsPerPage: number) => {
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1);
  };

  const formatDateTime = (dateStr: string | null | undefined) => {
    if (!dateStr) return 'N/A';
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return 'N/A';
    return `${format(date, 'dd/MM/yyyy')} ∙${format(date, 'HH:mm')}`;
  };

  const handleSort = (field: keyof TemplateRow) => {
    debugger;
    if (sortField === field) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortOrder('asc');
    }
  };

  // Fetches the full (unpaginated) list from whichever WP endpoint matches
  // the same routing logic the page already uses for normal fetches:
  //   - a filter/subfilter is active  -> GetOperatorTemplatesWithFilterWP
  //   - campaign tab, no filter       -> GetTemplatesByOperatorIdWP
  //   - welcome tab, no filter        -> GetWelcomeTemplatesByPartnerWP
  const fetchAllTemplatesForExport = async (): Promise<TemplateRow[]> => {
    if (!operatorId || !operatorUrl) return [];

    const hasFilter =
      filterData.filter !== 'None' && filterData.subFilter !== '';

    try {
      if (hasFilter) {
        const response = await axios.get(
          `${operatorUrl}/GetOperatorTemplatesWithFilterWP`,
          {
            params: {
              operatorId,
              templateType:
                activeTemplateTab === 'campaign' ? 'campaign' : 'welcome',
              criteria: filterData.filter,
              subFilter: filterData.subFilter,
            },
          },
        );
        return response.data?.templates ?? [];
      }

      if (activeTemplateTab === 'campaign') {
        const response = await axios.get(
          `${operatorUrl}/GetTemplatesByOperatorIdWP`,
          {
            params: {
              operatorId,
              searchTerm: searchTerm || null,
            },
          },
        );
        return response.data?.templatesDetails ?? [];
      }

      const response = await axios.get(
        `${operatorUrl}/GetWelcomeTemplatesByPartnerWP`,
        {
          params: {
            partnerId: operatorId,
            searchTerm: searchTerm || null,
          },
        },
      );
      return response.data?.templates ?? [];
    } catch (error) {
      console.error('Error fetching templates for export:', error);
      toast.toast({
        title: 'Error',
        description: 'Failed to fetch templates for export.',
      });
      return [];
    }
  };

  const handleExportButtonClick = async () => {
    setIsExporting(true);
    try {
      const allTemplates = await fetchAllTemplatesForExport();
      const isCampaignTab = activeTemplateTab === 'campaign';

      const formatLastUpdated = (last_updated: string) =>
        last_updated
          ? new Date(last_updated).toLocaleString('en-IN', {
              year: 'numeric',
              month: 'short',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
            })
          : '';

      // Campaign templates report: no status, no isUsedAsWm
      // Welcome templates report: includes status + isUsedAsWm
      const filteredData = allTemplates.map((t) =>
        isCampaignTab
          ? {
              operator_mapping_id: t.operator_mapping_id,
              template_id: t.template_id,
              template_name: t.template_name,
              campaign_name: t.campaign_name,
              channel_type: t.channel_type,
              whatsapp_status: t.status,
              template_type: 'CAMPAIGN',
              last_updated: formatLastUpdated(t.last_updated),
            }
          : {
              template_id: t.template_id,
              template_name: t.template_name,
              channel_type: t.channel_type,
              template_type: t.template_type,
              status: t.status,
              whatsapp_status: t.whatsapp_status,
              last_updated: formatLastUpdated(t.last_updated),
            },
      );

      // Create worksheet from filtered data
      const worksheet = XLSX.utils.json_to_sheet(filteredData);

      // Create and populate workbook
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        isCampaignTab ? 'Campaign_Template_List' : 'Welcome_Template_List',
      );

      // Export to an xlsx file
      XLSX.writeFile(
        workbook,
        isCampaignTab
          ? 'OperatorCampaignTemplateList.xlsx'
          : 'OperatorWelcomeTemplateList.xlsx',
      );
    } finally {
      setIsExporting(false);
    }
  };

  const sortedTemplates = React.useMemo(() => {
    if (!sortField) return templateList;
    const sorted = [...templateList].sort((a, b) => {
      const aField = a[sortField];
      const bField = b[sortField];
      if (aField == null) return 1;
      if (bField == null) return -1;

      if (typeof aField === 'string' && typeof bField === 'string') {
        return sortOrder === 'asc'
          ? aField.localeCompare(bField)
          : bField.localeCompare(aField);
      }

      if (typeof aField === 'number' && typeof bField === 'number') {
        return sortOrder === 'asc' ? aField - bField : bField - aField;
      }

      // Dates as string ISO format
      // if (sortField === "last_updated") {
      //   const aDate = new Date(aField);
      //   const bDate = new Date(bField);
      //   return sortOrder === "asc"
      //     ? aDate.getTime() - bDate.getTime()
      //     : bDate.getTime() - aDate.getTime();
      // }

      if (sortField === 'last_updated') {
        const aDate = new Date(aField as string);
        const bDate = new Date(bField as string);

        return sortOrder === 'asc'
          ? aDate.getTime() - bDate.getTime()
          : bDate.getTime() - aDate.getTime();
      }

      return 0;
    });

    return sorted;
  }, [templateList, sortField, sortOrder]);

  // const displayedTemplates = sortedTemplates.filter(
  //   (t) =>
  //     t.template_type ===
  //     (activeTemplateTab === "campaign" ? "CAMPAIGN" : "WELCOME"),
  // );
  const displayedTemplates = sortedTemplates;

  // const renderStatusIcon = (status: string) => {
  //   switch (status?.toLowerCase()) {
  //     case "approved":
  //       return <CheckCircle className="text-green-500 h-4 w-4" />;
  //     case "pending":
  //       return <Clock className="text-yellow-500 h-4 w-4" />;
  //     case "rejected":
  //       return <XCircle className="text-red-500 h-4 w-4" />;
  //     default:
  //       return <HelpCircle className="text-gray-400 h-4 w-4" />;
  //   }
  // };

  const renderStatusIcon = (status?: string | null) => {
    if (!status) return null; // 🔥 KEY FIX – no icon for null/undefined/empty

    switch (status.toLowerCase()) {
      case 'approved':
        return <CheckCircle className='text-green-500 h-4 w-4' />;

      case 'pending':
        return <Clock className='text-yellow-500 h-4 w-4' />;

      case 'rejected':
        return <XCircle className='text-red-500 h-4 w-4' />;

      default:
        return null; // 🔥 also hide for unknown values
    }
  };

  const handleSelectAll = () => {
    if (isAllSelected) {
      setCheckboxSelectedRows([]);
    } else {
      const allIds = currentTemplates.map((template) => template.template_id);
      setCheckboxSelectedRows(allIds);
    }
    setIsAllSelected(!isAllSelected);
  };

  const handleCheckboxRowSelect = (id: number) => {
    setCheckboxSelectedRows((prev) => {
      const newSelectedRows = prev.includes(id)
        ? prev.filter((rowId) => rowId !== id)
        : [...prev, id];
      setIsAllSelected(newSelectedRows.length === currentTemplates.length); // Update `isAllSelected` if all rows are selected
      return newSelectedRows;
    });
  };

  // const handleRefreshTemplates = async () => {
  //   setIsRefreshing(true); // Start refresh UI

  //   await fetchTemplates(currentPage, rowsPerPage, searchTerm); // Call with current state values

  //   setIsRefreshing(false); // Reset refresh UI
  // };

  const handleRefreshTemplates = async () => {
    setIsRefreshing(true);

    await fetchTemplatesByTab(currentPage, rowsPerPage, searchTerm);

    setIsRefreshing(false);
  };

  // Determine if we should show table or fallback UI
  const shouldShowTable =
    everHadTemplates ||
    searchTerm.trim() !== '' ||
    filterData.filter !== 'None' ||
    loading;
  const shouldShowFallback =
    !everHadTemplates &&
    initialFetched &&
    searchTerm.trim() === '' &&
    filterData.filter === 'None' &&
    !loading;

  const totalPages: number = Math.ceil(totalCount / rowsPerPage);
  const currentTemplates = templateList;

  const handleCreateTemplate = () => {
    setDialogMode('create');
    setSelectedTemplate(null);
    setOpenTemplateDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenTemplateDialog(false);
    setSelectedTemplate(null);
  };

  const handleSaveTemplate = (templateData: any) => {
    console.log('Template saved:', templateData);
    // Refresh the template list after save
    // fetchTemplates();
    // Close the dialog
    setOpenTemplateDialog(false);
  };

  // return (
  //   <div>
  //     <div className="fixed flex justify-end items-end right-0 top-[-24px] z-20 p-4 mr-2">
  //               <Button
  //                   className="w-36 text-sm text-[#F8FAFC] font-medium h-[35px]"
  //                   onClick={handleCreateTemplate}
  //               >
  //                   Create Template
  //               </Button>
  //     </div>
  //     <ToastContainer />
  //     {loading ? (
  //       <div className="flex flex-col items-center justify-center h-[500px]">
  //         <CircularProgress color="primary" />
  //       </div>
  //     ) : (
  //       <div>
  //         {/* Search & Filter Section */}
  //         <div className="flex mt-2">
  //           <div>
  //             <Input
  //               placeholder="Search campaign by name..."
  //               className="w-[350px] text-[14px] font-normal text-[#64748B]"
  //               value={searchTerm}
  //               onChange={(e) => {
  //                 const newValue = e.target.value;
  //                 if (searchTerm.trim() !== "" && newValue.trim() === "") {
  //                   setIsClearingSearch(true);
  //                 }
  //                 setSearchTerm(newValue);
  //               }}
  //             />
  //           </div>
  //           <div className="flex items-end ml-auto">
  //             <Button
  //               variant="default"
  //               className="w-auto bg-[#479E98] mb-6 ml-4 mt-[-6px]"
  //               onClick={handleRefreshTemplates}
  //               disabled={isRefreshing}
  //             >
  //               <RefreshCw className="mr-2 h-4 w-4" />

  //               {isRefreshing ? "Refreshing..." : "Refresh"}
  //             </Button>
  //             <OperatorTemplateDropdown
  //               setFilterData={setFilterData}
  //               filterData={filterData}
  //               dateList={dateList}
  //             />
  //           </div>
  //           <div className="flex items-end justify-end">
  //             <Button
  //               variant="outline"
  //               className="w-24 mb-6 ml-4 mt-[-6px] text-[#020617]"
  //               onClick={handleExportButtonClick}
  //             >
  //               <FileIcon
  //                 style={{ width: "14px", height: "14px" }}
  //                 className="mr-1 text-[#020617]"
  //               />
  //               Export
  //             </Button>
  //           </div>
  //         </div>

  //         <div className="flex overflow-hidden w-full justify-start mb-3">
  //           <Tabs
  //             value={activeTemplateTab}
  //             onValueChange={(val) => {
  //               setActiveTemplateTab(val as "campaign" | "welcome");
  //               setCurrentPage(1);
  //               setCheckboxSelectedRows([]);
  //               setIsAllSelected(false);
  //               //setLoading(true); // 🔥 start loading body only
  //             }}
  //           >
  //             <TabsList>
  //               <TabsTrigger value="campaign">Campaign Templates</TabsTrigger>
  //               <TabsTrigger value="welcome">Welcome Templates</TabsTrigger>
  //             </TabsList>
  //           </Tabs>
  //         </div>

  //         {/* Table Section */}
  //         <div className="rounded-md border overflow-x-auto mt-4">
  //           <div className="max-h-[60vh] overflow-y-auto">
  //             <Table
  //               className="rounded-xl whitespace-nowrap border-gray-200"
  //               style={{ color: "#020202", fontSize: "15px" }}
  //             >
  //               <TableHeader className="text-center text-[14px] font-medium">
  //                 <TableRow>
  //                   <TableHead>
  //                     <div className="flex items-center gap-6 justify-start cursor-pointer">
  //                       <input
  //                         type="checkbox"
  //                         className={`text-muted-foreground ${isAllSelected ? "accent-gray-700 bg-grey-700" : ""
  //                           }`}
  //                         checked={isAllSelected}
  //                       // onChange={handleSelectAll}
  //                       />
  //                       Template name
  //                       <CaretSortIcon
  //                         className="cursor-pointer"
  //                         onClick={() => handleSort("template_name")}
  //                       />
  //                     </div>
  //                   </TableHead>
  //                   {activeTemplateTab === "campaign" && (
  //                     <TableHead className="text-left">
  //                       <div className="flex items-center gap-2 justify-start">
  //                         Campaign name
  //                         <CaretSortIcon
  //                           className="cursor-pointer"
  //                           onClick={() => handleSort("campaign_name")}
  //                         />
  //                       </div>
  //                     </TableHead>
  //                   )}

  //                   <TableHead className="text-left">
  //                     <div className="flex items-center gap-2 justify-start">
  //                       Channel{" "}
  //                       <CaretSortIcon
  //                         className="cursor-pointer"
  //                         onClick={() => handleSort("channel_type")}
  //                       />
  //                     </div>
  //                   </TableHead>
  //                   <TableHead className="text-left">
  //                     <div className="flex items-center gap-2 justify-start">
  //                       Status{" "}
  //                       <CaretSortIcon
  //                         className="cursor-pointer"
  //                         onClick={() => handleSort("status")}
  //                       />
  //                     </div>
  //                   </TableHead>
  //                   {activeTemplateTab === "welcome" && (
  //                     <TableHead className="text-left">
  //                       <div className="flex items-center gap-2 justify-start">
  //                         Meta Status
  //                         <CaretSortIcon
  //                           className="cursor-pointer"
  //                           onClick={() => handleSort("status")}
  //                         />
  //                       </div>
  //                     </TableHead>
  //                   )}
  //                   <TableHead className="text-left">
  //                     <div className="flex items-center gap-2 justify-start">
  //                       Last Updated{" "}
  //                       <CaretSortIcon
  //                         className="cursor-pointer"
  //                         onClick={() => handleSort("last_updated")}
  //                       />
  //                     </div>
  //                   </TableHead>
  //                 </TableRow>
  //               </TableHeader>
  //               <TableBody className="text-left text-[14px] font-normal text-[#020617]">
  //                 {/* 🔄 Loading state */}
  //                 {loading && (
  //                   <TableRow>
  //                     <TableCell
  //                       colSpan={activeTemplateTab === "campaign" ? 5 : 4}
  //                       className="text-center py-10"
  //                     >
  //                       <Loader2 className="h-6 w-6 animate-spin text-gray-500 mx-auto" />
  //                     </TableCell>
  //                   </TableRow>
  //                 )}
  //                 {/* ✅ Data rows */}
  //                 {!loading &&
  //                   displayedTemplates.map((template) => {
  //                     const isSelected = checkboxSelectedRows.includes(
  //                       template.template_id,
  //                     );

  //                     return (
  //                       <TableRow
  //                         key={template.template_id}
  //                         className={isSelected ? "bg-gray-200" : ""}
  //                       >
  //                         {/* Template Name */}
  //                         <TableCell className="py-4">
  //                           <div className="flex items-start gap-3">
  //                             <input
  //                               type="checkbox"
  //                               className="accent-gray-700 mt-1"
  //                               checked={isSelected}
  //                               onChange={() =>
  //                                 handleCheckboxRowSelect(template.template_id)
  //                               }
  //                             />
  //                             <span
  //                               className="font-medium cursor-pointer hover:text-blue-600 hover:underline"
  //                               onClick={() =>
  //                                 handleTemplateNameClick(template)
  //                               }
  //                             >
  //                               {template.template_name}
  //                             </span>
  //                           </div>
  //                         </TableCell>

  //                         {/* Campaign Name – only for Campaign tab */}
  //                         {activeTemplateTab === "campaign" && (
  //                           <TableCell className="py-4 text-muted-foreground">
  //                             {template.campaign_name || "-"}
  //                           </TableCell>
  //                         )}

  //                         {/* Channel */}
  //                         <TableCell className="py-4">
  //                           <Badge
  //                             className="text-white"
  //                             style={{
  //                               backgroundColor:
  //                                 template.channel_type === "WhatsApp"
  //                                   ? "#479E98"
  //                                   : template.channel_type === "SMS"
  //                                     ? "#DFA548"
  //                                     : "#ccc",
  //                             }}
  //                           >
  //                             {template.channel_type}
  //                           </Badge>
  //                         </TableCell>

  //                         {/* Status */}
  //                         <TableCell className="py-4 flex items-center gap-2">
  //                           {renderStatusIcon(template.status)}
  //                           <span>{template.status}</span>
  //                         </TableCell>

  //                         {activeTemplateTab === "welcome" && (
  //                           <TableCell className="py-4">
  //                             <div className="flex items-center gap-2 whitespace-nowrap">
  //                               {renderStatusIcon(template.whatsapp_status)}
  //                               <span>{template.whatsapp_status || "-"}</span>
  //                             </div>
  //                           </TableCell>
  //                         )}

  //                         {/* Last Updated */}
  //                         <TableCell className="py-4 text-muted-foreground">
  //                           {formatDateTime(template.last_updated)}
  //                         </TableCell>
  //                       </TableRow>
  //                     );
  //                   })}

  //                 {/* 🚫 Empty state */}
  //                 {!loading && displayedTemplates.length === 0 && (
  //                   <TableRow>
  //                     <TableCell
  //                       colSpan={activeTemplateTab === "campaign" ? 5 : 4}
  //                       className="text-center py-8 text-gray-500"
  //                     >
  //                       {activeTemplateTab === "campaign"
  //                         ? "No campaign templates available."
  //                         : "No welcome templates available."}
  //                     </TableCell>
  //                   </TableRow>
  //                 )}
  //               </TableBody>
  //             </Table>
  //           </div>
  //         </div>

  //         <TemplatePreviewModal
  //           isOpen={isPreviewModalOpen}
  //           onClose={() => setIsPreviewModalOpen(false)}
  //           template={selectedTemplate}
  //           onApprove={handleApprove}
  //           onReject={handleReject}
  //         />

  //         {/* Pagination */}
  //         {sortedTemplates.length > 0 && !loading && (
  //           <div className="flex justify-between items-center mt-4">
  //             <div className="text-gray-500 text-sm">
  //               {`Showing ${(currentPage - 1) * rowsPerPage + 1} - ${Math.min(
  //                 currentPage * rowsPerPage,
  //                 totalCount,
  //               )} of ${totalCount} templates`}
  //             </div>
  //             <div className="flex items-center space-x-4 font-medium text-sm">
  //               <span className="text-[#020617] font-medium text-[14px]">
  //                 Rows per page
  //               </span>
  //               <div className="relative inline-block ml-2">
  //                 <select
  //                   className="cursor-pointer border border-gray-300 rounded-md px-2 py-1 appearance-none focus:outline-none focus:ring-1 focus:ring-blue-500"
  //                   style={{
  //                     width: "60px",
  //                     height: "30px",
  //                     textAlign: "left",
  //                     fontSize: "12px",
  //                     fontWeight: "400",
  //                     borderColor: "#E5E7EB",
  //                     boxShadow: "inset 0 1px 2px rgba(0, 0, 0, 0.1)",
  //                   }}
  //                   value={rowsPerPage}
  //                   onChange={(e) =>
  //                     handleRowsPerPageChange(Number(e.target.value))
  //                   }
  //                 >
  //                   {[5, 10, 20].map((num) => (
  //                     <option key={num} value={num}>
  //                       {num}
  //                     </option>
  //                   ))}
  //                 </select>
  //                 <CaretSortIcon className="absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-500 w-4 h-4" />
  //               </div>

  //               <div className="ml-4 mr-4">
  //                 <span className="text-[#020617] text-[14px] font-medium">{`Page ${currentPage} of ${totalPages}`}</span>
  //               </div>

  //               <div className="flex items-center gap-2">
  //                 <button
  //                   disabled={currentPage === 1}
  //                   className={`border p-1 pr-2 pl-2 rounded text-gray-500 ${currentPage === 1
  //                       ? "cursor-not-allowed bg-gray-100"
  //                       : "hover:bg-gray-200"
  //                     }`}
  //                   onClick={() => handlePageChange(1)}
  //                 >
  //                   «
  //                 </button>
  //                 <button
  //                   disabled={currentPage === 1}
  //                   className={`border p-1 pr-2 pl-2 rounded text-gray-500 ${currentPage === 1
  //                       ? "cursor-not-allowed bg-gray-100"
  //                       : "hover:bg-gray-200"
  //                     }`}
  //                   onClick={() => handlePageChange(currentPage - 1)}
  //                 >
  //                   ‹
  //                 </button>
  //                 <button
  //                   disabled={currentPage === totalPages}
  //                   className={`border p-1 pr-2 pl-2 rounded text-gray-500 ${currentPage === totalPages
  //                       ? "cursor-not-allowed bg-gray-100"
  //                       : "hover:bg-gray-200"
  //                     }`}
  //                   onClick={() => handlePageChange(currentPage + 1)}
  //                 >
  //                   ›
  //                 </button>
  //                 <button
  //                   disabled={currentPage === totalPages}
  //                   className={`border p-1 pr-2 pl-2 rounded text-gray-500 ${currentPage === totalPages
  //                       ? "cursor-not-allowed bg-gray-100"
  //                       : "hover:bg-gray-200"
  //                     }`}
  //                   onClick={() => handlePageChange(totalPages)}
  //                 >
  //                   »
  //                 </button>
  //               </div>
  //             </div>
  //           </div>
  //         )}
  //       </div>
  //     )}
  //   <Dialog open={openTemplateDialog} onOpenChange={setOpenTemplateDialog}>
  //     <DialogContent className="max-w-6xl max-h-[90vh] overflow-y-auto">
  //       <CreateContentForm
  //         onClose={handleCloseDialog}
  //         onSave={handleSaveTemplate}
  //         initialContent={selectedTemplate}
  //         allTemplates={templateList}
  //         mode={dialogMode}
  //       />
  //     </DialogContent>
  //   </Dialog>
  //   </div>
  // );
  return (
    <div>
      <div className='fixed flex justify-end items-end right-0 top-[-24px] z-20 p-4 mr-2'>
        <Button
          className='w-36 text-sm text-[#F8FAFC] font-medium h-[35px]'
          onClick={handleCreateTemplate}
        >
          Create Template
        </Button>
      </div>
      <Toaster />
      {loading ? (
        <div className='flex flex-col items-center justify-center h-[500px]'>
          <CircularProgress color='primary' />
        </div>
      ) : (
        <div>
          {/* Search & Filter Section */}
          <div className='flex mt-2'>
            <div>
              <Input
                placeholder='Search campaign by name...'
                className='w-[350px] text-[14px] font-normal text-[#64748B]'
                value={searchTerm}
                onChange={(e) => {
                  const newValue = e.target.value;
                  if (searchTerm.trim() !== '' && newValue.trim() === '') {
                    setIsClearingSearch(true);
                  }
                  setSearchTerm(newValue);
                }}
              />
            </div>
            <div className='flex items-end ml-auto'>
              <Button
                variant='default'
                className='w-auto bg-[#479E98] mb-6 ml-4 mt-[-6px]'
                onClick={handleRefreshTemplates}
                disabled={isRefreshing}
              >
                <RefreshCw className='mr-2 h-4 w-4' />

                {isRefreshing ? 'Refreshing...' : 'Refresh'}
              </Button>
              <OperatorTemplateDropdown
                setFilterData={setFilterData}
                filterData={filterData}
                dateList={dateList}
              />
            </div>
            <div className='flex items-end justify-end'>
              <Button
                variant='outline'
                className='w-24 mb-6 ml-4 mt-[-6px] text-[#020617]'
                onClick={handleExportButtonClick}
                disabled={isExporting}
              >
                {isExporting ? (
                  'Exporting...'
                ) : (
                  <>
                    <FileIcon
                      style={{ width: '14px', height: '14px' }}
                      className='mr-1 text-[#020617]'
                    />
                    Export
                  </>
                )}
              </Button>
            </div>
          </div>

          <div className='flex overflow-hidden w-full justify-start mb-3'>
            <Tabs
              value={activeTemplateTab}
              onValueChange={(val) => {
                setActiveTemplateTab(val as 'campaign' | 'welcome');
                setCurrentPage(1);
                setCheckboxSelectedRows([]);
                setIsAllSelected(false);
                //setLoading(true); // 🔥 start loading body only
              }}
            >
              <TabsList>
                <TabsTrigger value='campaign'>Campaign Templates</TabsTrigger>
                <TabsTrigger value='welcome'>Welcome Templates</TabsTrigger>
              </TabsList>
            </Tabs>
          </div>

          {/* Table Section */}
          <div className='rounded-md border overflow-x-auto mt-4'>
            <div className='max-h-[60vh] overflow-y-auto'>
              <Table
                className='rounded-xl whitespace-nowrap border-gray-200'
                style={{ color: '#020202', fontSize: '15px' }}
              >
                <TableHeader className='text-center text-[14px] font-medium'>
                  <TableRow>
                    <TableHead>
                      <div className='flex items-center gap-6 justify-start cursor-pointer'>
                        <input
                          type='checkbox'
                          className={`text-muted-foreground ${
                            isAllSelected ? 'accent-gray-700 bg-grey-700' : ''
                          }`}
                          checked={isAllSelected}
                          // onChange={handleSelectAll}
                        />
                        Template name
                        <CaretSortIcon
                          className='cursor-pointer'
                          onClick={() => handleSort('template_name')}
                        />
                      </div>
                    </TableHead>
                    {activeTemplateTab === 'campaign' && (
                      <TableHead className='text-left'>
                        <div className='flex items-center gap-2 justify-start'>
                          Campaign name
                          <CaretSortIcon
                            className='cursor-pointer'
                            onClick={() => handleSort('campaign_name')}
                          />
                        </div>
                      </TableHead>
                    )}

                    <TableHead className='text-left'>
                      <div className='flex items-center gap-2 justify-start'>
                        Channel{' '}
                        <CaretSortIcon
                          className='cursor-pointer'
                          onClick={() => handleSort('channel_type')}
                        />
                      </div>
                    </TableHead>
                    <TableHead className='text-left'>
                      <div className='flex items-center gap-2 justify-start'>
                        Status{' '}
                        <CaretSortIcon
                          className='cursor-pointer'
                          onClick={() => handleSort('status')}
                        />
                      </div>
                    </TableHead>
                    {activeTemplateTab === 'welcome' && (
                      <TableHead className='text-left'>
                        <div className='flex items-center gap-2 justify-start'>
                          Meta Status
                          <CaretSortIcon
                            className='cursor-pointer'
                            onClick={() => handleSort('status')}
                          />
                        </div>
                      </TableHead>
                    )}
                    <TableHead className='text-left'>
                      <div className='flex items-center gap-2 justify-start'>
                        Last Updated{' '}
                        <CaretSortIcon
                          className='cursor-pointer'
                          onClick={() => handleSort('last_updated')}
                        />
                      </div>
                    </TableHead>

                    {/* ✅ ADD THIS */}
                    <TableHead className='w-12'></TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody className='text-left text-[14px] font-normal text-[#020617]'>
                  {/* 🔄 Loading state */}
                  {loading && (
                    <TableRow>
                      <TableCell
                        colSpan={activeTemplateTab === 'campaign' ? 5 : 4}
                        className='text-center py-10'
                      >
                        <Loader2 className='h-6 w-6 animate-spin text-gray-500 mx-auto' />
                      </TableCell>
                    </TableRow>
                  )}
                  {/* ✅ Data rows */}
                  {!loading &&
                    displayedTemplates.map((template) => {
                      const isSelected = checkboxSelectedRows.includes(
                        template.template_id,
                      );
                      const canEdit = template.status
                        .toLowerCase()
                        .includes('rejected');

                      return (
                        <TableRow
                          key={template.template_id}
                          className={isSelected ? 'bg-gray-200' : ''}
                        >
                          {/* Template Name */}
                          <TableCell className='py-4'>
                            <div className='flex items-start gap-3'>
                              <input
                                type='checkbox'
                                className='accent-gray-700 mt-1'
                                checked={isSelected}
                                onChange={() =>
                                  handleCheckboxRowSelect(template.template_id)
                                }
                              />
                              <span
                                className='font-medium cursor-pointer hover:text-blue-600 hover:underline'
                                onClick={() => {
                                  if (activeTemplateTab === 'welcome') {
                                    handleTemplateNameClick(template);
                                  }
                                  if (activeTemplateTab === 'campaign') {
                                    handleCampaignTemplateClick(template);
                                  }
                                }}
                              >
                                {template.template_name}
                              </span>
                            </div>
                          </TableCell>

                          {/* Campaign Name – only for Campaign tab */}
                          {activeTemplateTab === 'campaign' && (
                            <TableCell className='py-4 text-muted-foreground'>
                              {template.campaign_name || '-'}
                            </TableCell>
                          )}

                          {/* Channel */}
                          <TableCell className='py-4'>
                            <Badge
                              className='text-white'
                              style={{
                                backgroundColor:
                                  template.channel_type === 'WhatsApp'
                                    ? '#479E98'
                                    : template.channel_type === 'SMS'
                                      ? '#DFA548'
                                      : '#ccc',
                              }}
                            >
                              {template.channel_type}
                            </Badge>
                          </TableCell>

                          {/* Status */}
                          {/* Status */}
                          <TableCell className='py-4'>
                            <div className='flex items-center gap-2'>
                              {renderStatusIcon(template.status)}
                              <span className='capitalize'>
                                {template.status}
                              </span>
                            </div>
                          </TableCell>

                          {/* Meta Status */}
                          {activeTemplateTab === 'welcome' && (
                            <TableCell className='py-4'>
                              <div className='flex items-center gap-2'>
                                {template.whatsapp_status ? (
                                  <>
                                    {renderStatusIcon(template.whatsapp_status)}
                                    <span className='capitalize'>
                                      {template.whatsapp_status}
                                    </span>
                                  </>
                                ) : (
                                  <span>-</span>
                                )}
                              </div>
                            </TableCell>
                          )}

                          {/* Last Updated */}
                          <TableCell className='py-4 text-muted-foreground whitespace-nowrap'>
                            {template.last_updated
                              ? formatDateTime(template.last_updated)
                              : '-'}
                          </TableCell>
                          {/* Last Updated */}

                          {/* ✅ ADD THIS - 3-dots Actions menu (Welcome tab only) */}
                          {activeTemplateTab === 'welcome' && (
                            <TableCell className='py-2 pr-3 align-middle'>
                              <DropdownMenu
                                open={openMenuRowId === template.template_id}
                                onOpenChange={(open) =>
                                  setOpenMenuRowId(
                                    open ? template.template_id : null,
                                  )
                                }
                              >
                                <DropdownMenuTrigger asChild>
                                  <Button
                                    variant='ghost'
                                    className='h-8 w-8 p-0'
                                  >
                                    <DotsHorizontalIcon className='h-4 w-4' />
                                  </Button>
                                </DropdownMenuTrigger>
                                {openMenuRowId === template.template_id && (
                                  <DropdownMenuContent
                                    align='end'
                                    className='w-40 bg-white shadow-lg rounded-md'
                                  >
                                    <DropdownMenuItem
                                      onClick={() =>
                                        handleView(template.template_id)
                                      }
                                    >
                                      View
                                    </DropdownMenuItem>
                                    {canEdit && (
                                      <DropdownMenuItem
                                        onClick={() =>
                                          handleEdit(template.template_id)
                                        }
                                      >
                                        Edit
                                      </DropdownMenuItem>
                                    )}
                                    {!template.isUsedAsWm && (
                                      <DropdownMenuItem
                                        onClick={() =>
                                          handleDelete(template.template_id)
                                        }
                                        className='text-red-600'
                                      >
                                        Delete
                                      </DropdownMenuItem>
                                    )}
                                  </DropdownMenuContent>
                                )}
                              </DropdownMenu>
                            </TableCell>
                          )}
                        </TableRow>
                      );
                    })}

                  {/* 🚫 Empty state */}
                  {!loading && displayedTemplates.length === 0 && (
                    <TableRow>
                      <TableCell
                        colSpan={activeTemplateTab === 'campaign' ? 5 : 4}
                        className='text-center py-8 text-gray-500'
                      >
                        {activeTemplateTab === 'campaign'
                          ? 'No campaign templates available.'
                          : 'No welcome templates available.'}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </div>
          </div>

          {isDeleted ? (
            <Dialog
              open={isPreviewModalOpen}
              onOpenChange={setIsPreviewModalOpen}
            >
              <DialogContent className='max-w-2xl'>
                <DialogHeader>
                  <DialogTitle className='sr-only'>
                    Template Deleted
                  </DialogTitle>
                </DialogHeader>

                <div className='flex flex-col items-center justify-center py-10'>
                  <div className='flex items-center justify-center w-16 h-16 rounded-full bg-gray-100'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      className='w-8 h-8 text-gray-400'
                      fill='none'
                      viewBox='0 0 24 24'
                      stroke='currentColor'
                      strokeWidth={1.5}
                    >
                      <path
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        d='M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6M9 7h6m2 0a2 2 0 00-2-2H9a2 2 0 00-2 2m10 0H5'
                      />
                    </svg>
                  </div>
                  <h2 className='text-2xl font-semibold mb-2'>
                    Template Deleted
                  </h2>
                  <p className='text-gray-500 text-center max-w-md'>
                    This welcome template was deleted and no more actions are
                    required.
                  </p>
                </div>
              </DialogContent>
            </Dialog>
          ) : (
            <TemplatePreviewModal
              isOpen={isPreviewModalOpen}
              onClose={() => setIsPreviewModalOpen(false)}
              template={selectedTemplate}
              operatorUrl={operatorUrl}
              templateId={selectedTemplateId}
              templateName={selectedTemplateName || ''}
              accountId={accountId}
              workspaceId={operatorId}
              onRefreshList={() =>
                fetchWelcomeTemplates(currentPage, rowsPerPage, searchTerm)
              }
              isApproved={selectedTemplate?.operator_status === 'approved'}
              isRejected={selectedTemplate?.operator_status === 'rejected'}
              isCampaignPreview={isCampaignTemplatePreview}
            />
          )}

          {/* Pagination */}
          {sortedTemplates.length > 0 && !loading && (
            <div className='flex justify-between items-center mt-4'>
              <div className='text-gray-500 text-sm'>
                {`Showing ${(currentPage - 1) * rowsPerPage + 1} - ${Math.min(
                  currentPage * rowsPerPage,
                  totalCount,
                )} of ${totalCount} templates`}
              </div>
              <div className='flex items-center space-x-4 font-medium text-sm'>
                <span className='text-[#020617] font-medium text-[14px]'>
                  Rows per page
                </span>
                <div className='relative inline-block ml-2'>
                  <select
                    className='cursor-pointer border border-gray-300 rounded-md px-2 py-1 appearance-none focus:outline-none focus:ring-1 focus:ring-blue-500'
                    style={{
                      width: '60px',
                      height: '30px',
                      textAlign: 'left',
                      fontSize: '12px',
                      fontWeight: '400',
                      borderColor: '#E5E7EB',
                      boxShadow: 'inset 0 1px 2px rgba(0, 0, 0, 0.1)',
                    }}
                    value={rowsPerPage}
                    onChange={(e) =>
                      handleRowsPerPageChange(Number(e.target.value))
                    }
                  >
                    {[5, 10, 20].map((num) => (
                      <option key={num} value={num}>
                        {num}
                      </option>
                    ))}
                  </select>
                  <CaretSortIcon className='absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-500 w-4 h-4' />
                </div>

                <div className='ml-4 mr-4'>
                  <span className='text-[#020617] text-[14px] font-medium'>{`Page ${currentPage} of ${totalPages}`}</span>
                </div>

                <div className='flex items-center gap-2'>
                  <button
                    disabled={currentPage === 1}
                    className={`border p-1 pr-2 pl-2 rounded text-gray-500 ${
                      currentPage === 1
                        ? 'cursor-not-allowed bg-gray-100'
                        : 'hover:bg-gray-200'
                    }`}
                    onClick={() => handlePageChange(1)}
                  >
                    «
                  </button>
                  <button
                    disabled={currentPage === 1}
                    className={`border p-1 pr-2 pl-2 rounded text-gray-500 ${
                      currentPage === 1
                        ? 'cursor-not-allowed bg-gray-100'
                        : 'hover:bg-gray-200'
                    }`}
                    onClick={() => handlePageChange(currentPage - 1)}
                  >
                    ‹
                  </button>
                  <button
                    disabled={currentPage === totalPages}
                    className={`border p-1 pr-2 pl-2 rounded text-gray-500 ${
                      currentPage === totalPages
                        ? 'cursor-not-allowed bg-gray-100'
                        : 'hover:bg-gray-200'
                    }`}
                    onClick={() => handlePageChange(currentPage + 1)}
                  >
                    ›
                  </button>
                  <button
                    disabled={currentPage === totalPages}
                    className={`border p-1 pr-2 pl-2 rounded text-gray-500 ${
                      currentPage === totalPages
                        ? 'cursor-not-allowed bg-gray-100'
                        : 'hover:bg-gray-200'
                    }`}
                    onClick={() => handlePageChange(totalPages)}
                  >
                    »
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      <Dialog open={openTemplateDialog} onOpenChange={setOpenTemplateDialog}>
        <DialogContent className='max-w-6xl max-h-[90vh] overflow-y-auto'>
          <DialogHeader>
            <DialogTitle className='text-2xl font-bold'>
              {dialogMode === 'create'
                ? 'Create Template'
                : dialogMode === 'edit'
                  ? 'Edit Template'
                  : 'View Template'}
            </DialogTitle>
          </DialogHeader>

          <CreateContentForm
            onClose={handleCloseDialog}
            onSave={handleSaveTemplate}
            initialContent={selectedTemplate}
            allTemplates={templateList}
            mode={dialogMode}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default OperatorTemplateList;
